const checkMax = (evt) => {
    if(window.uoeMaxPurchase === true){
        const newButton = document.createElement('button');
        newButton.classList.add("button","button--full-width","button--secondary");
        newButton.disabled = true;
        newButton.innerText = "Max number in cart";
        const span = document.createElement('span');
        span.classList.add('loading-overlay__spinner');
        newButton.appendChild(span);
        document.querySelector('product-form button.product-form__submit').replaceWith(newButton);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.cartUpdate, checkMax);
});